// Business/terminology configuration — SOURCE-CONTROLLED, not generated.
// Per-tenant presets keyed by the organization's `type` (medication | exercise |
// treatment), returned by /auth/me as `orgType`. Every consumer reads
// `config.terminology`; AdminApp swaps it to the signed-in org's preset at login.
// The default export stays the medication vocabulary for the pre-auth render.

// Generic vocab that is the same across all org types (a note is a note, a
// document is a document). Spread into every preset so no key is ever missing —
// components reference t.item / t.protocol / t.service / t.client / t.note / t.document.
const common = {
  note: {
    singular: 'Note',
    plural: 'Notes',
    singularLower: 'note',
    pluralLower: 'notes'
  },
  document: {
    singular: 'Document',
    plural: 'Documents',
    singularLower: 'document',
    pluralLower: 'documents'
  }
};

const medication = {
  ...common,
  // Individual item (e.g., "Medication", "Exercise", "Treatment")
  item: {
    singular: 'Medication',
    plural: 'Medications',
    singularLower: 'medication',
    pluralLower: 'medications'
  },
  // Protocol/Program (e.g., "Protocol", "Workout Program", "Treatment Plan")
  protocol: {
    singular: 'Protocol',
    plural: 'Protocols',
    singularLower: 'protocol',
    pluralLower: 'protocols'
  },
  // Services/Appointments (e.g., "Service", "Session", "Appointment")
  service: {
    singular: 'Service',
    plural: 'Services',
    singularLower: 'service',
    pluralLower: 'services'
  },
  // Clients/Patients (e.g., "Patient", "Client", "Member")
  client: {
    singular: 'Patient',
    plural: 'Patients',
    singularLower: 'patient',
    pluralLower: 'patients'
  }
};

const exercise = {
  ...common,
  item: {
    singular: 'Exercise',
    plural: 'Exercises',
    singularLower: 'exercise',
    pluralLower: 'exercises'
  },
  protocol: {
    singular: 'Program',
    plural: 'Programs',
    singularLower: 'program',
    pluralLower: 'programs'
  },
  service: {
    singular: 'Session',
    plural: 'Sessions',
    singularLower: 'session',
    pluralLower: 'sessions'
  },
  client: {
    singular: 'Client',
    plural: 'Clients',
    singularLower: 'client',
    pluralLower: 'clients'
  }
};

const treatment = {
  ...common,
  item: {
    singular: 'Treatment',
    plural: 'Treatments',
    singularLower: 'treatment',
    pluralLower: 'treatments'
  },
  protocol: {
    singular: 'Plan',
    plural: 'Plans',
    singularLower: 'plan',
    pluralLower: 'plans'
  },
  service: {
    singular: 'Service',
    plural: 'Services',
    singularLower: 'service',
    pluralLower: 'services'
  },
  client: {
    singular: 'Patient',
    plural: 'Patients',
    singularLower: 'patient',
    pluralLower: 'patients'
  }
};

export const TERMINOLOGY_PRESETS = { medication, exercise, treatment };

// Resolve the preset for an org type; unknown/absent falls back to medication.
export function terminologyFor(orgType) {
  return TERMINOLOGY_PRESETS[orgType] || medication;
}

// Default export = medication vocabulary (used by config.js for the initial,
// pre-authentication render).
export default medication;
